import * as React from 'react';
import { forwardRef, useCallback } from 'react';
import { useDispatch, useSelector } from '@/state/store';
import { stateUser, stateLoginWindow } from '@/selectors/selectors';
import { changeLoginWindow } from '@/actions/loginActions';
import { LoginWindowState } from '@/state';

const LoginButton = forwardRef<HTMLButtonElement>((_, ref) => {
    const dispatch = useDispatch();
    const loginState = useSelector(stateLoginWindow);
    const { isLoggedIn } = useSelector(stateUser);
    const onClick = useCallback(() => {
        dispatch(changeLoginWindow(LoginWindowState.LOGIN));
    }, [dispatch]);
    const iconColor = loginState === LoginWindowState.LOGIN ? 'orange' : 'inherit';

    return (
        <button
            ref={ref}
            type="button"
            aria-controls="loginpage"
            aria-owns="loginpage"
            aria-label="Innlogging"
            onClick={onClick}
            className="c-auth-button o-btn-square"
            title="Innlogging"
        >
            {isLoggedIn ? (
                <i
                    className="material-icons"
                    aria-hidden="true"
                    style={{ color: iconColor }}
                >
                    lock
                </i>
            ) : (
                <i
                    className="material-icons"
                    aria-hidden="true"
                    style={{ color: iconColor }}
                >
                    lock_open
                </i>
            )}
        </button>
    );
});
LoginButton.displayName = 'LoginButton';
export { LoginButton };
